import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-fail',
  templateUrl: './fail.component.html',
  styleUrls: ['./fail.component.scss'],
})
export class FailComponent implements OnInit, OnDestroy {
  @Input() message = '';

  private readonly destroy$ = new Subject<void>();

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit() {
    /** Récupérer le message erreur s'il existe depuis les paramètres */
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      if (params && params['error']) {
        this.message = params['error'];
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
